function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 24c-.827 0-1.5-.673-1.5-1.5v-21C2 .673 2.673 0 3.5 0h13.293c.4.003.787.167 1.064.45l3.703 3.696c.284.284.44.661.44 1.061V22.5c0 .827-.673 1.5-1.5 1.5h-17zm0-23a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h17a.5.5 0 00.5-.5V5.207a.501.501 0 00-.146-.354l-3.707-3.699A.507.507 0 0016.789 1H3.5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 16.504a.5.5 0 01-.354-.146l-3.5-3.5a.501.501 0 010-.708l3.5-3.5a.5.5 0 01.854.354.5.5 0 01-.146.354l-3.146 3.146 3.146 3.146a.5.5 0 01-.354.854zM14 16.504a.5.5 0 01-.354-.854l3.146-3.146-3.146-3.146A.5.5 0 0114 8.504a.5.5 0 01.354.146l3.5 3.5a.5.5 0 010 .708l-3.5 3.5a.5.5 0 01-.354.146z"
});

function SvgConfig(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "config.b82a3.svg";
export { SvgConfig as ReactComponent };